import r from "prop-types";
import { parseInt as c } from "lodash";
import * as o from "mintel-tokens";
function u(e) {
  return c(e, 10);
}
r.oneOfType([
  r.string,
  r.shape({
    pathname: r.string.isRequired,
    search: r.string,
    state: r.string,
    hash: r.string
  })
]);
const d = r.oneOfType([
  r.func,
  r.shape({ current: r.any })
]), g = r.oneOf(["compere", "default"]), m = (e, n, t) => {
  const a = t.includes("Modal") ? "title" : "label";
  if (!e.ariaLabelledBy && !e[a])
    return new Error(
      `Missing required prop in ${t} component. Please provide either '${a}' or 'ariaLabelledBy'`
    );
  if (e[n]) {
    const i = typeof e[n];
    if (i !== "string")
      return new Error(
        `Invalid prop ${n} of type ${i} supplied to ${t} component, expected 'string' ${e[n]}`
      );
  }
}, h = (e) => e?.replace(/\s+/g, "-").toLowerCase(), y = (e, n) => {
  let t = !1;
  const a = Object.keys(o).find(
    (l) => o[l] === e
  ), i = /\d+/g, s = a?.match(i);
  return s ? s[0] === "300" ? console.warn(
    `${n} received a 'color' prop in the mid-range (300).`,
    "Please pass a Mintel color constant either at or below 200 orat or higher than 400"
  ) : Number(s[0]) >= 400 && (t = !0) : [
    o.mintelBlack,
    o.mintelRoyal,
    o.cmBlack,
    o.cmPlum
  ].includes(e) && (t = !0), t;
};
export {
  m as L,
  g as a,
  y as g,
  u as p,
  d as r,
  h as t
};
